import aplicacaoCampanha from './aplicacao-campanha'
import baixa from './baixa'
import cadastroCampanha from './cadastro-campanha'
import consultaEstoque from './consulta-estoque'
import distribuicao from './distribuicao'
import entrada from './entrada'
import exportacao from './exportacao'
import filaAtendimento from './fila-atendimento'
import parametrizacao from './parametrizacao'
import registroVacinacao from './registro-vacinacao'
import relatorioConsolidadoAplicacao from './relatorio-consolidado-aplicacao'
import relatorioDeAplicacao from './relatorio-de-aplicacao'
import requisicao from './requisicao'
import salaVacinacao from './sala-vacinacao'

export default [
    {
        path: 'imunizacao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...aplicacaoCampanha,
            ...baixa,
            ...cadastroCampanha,
            ...consultaEstoque,
            ...distribuicao,
            ...entrada,
            ...exportacao,
            ...filaAtendimento,
            ...parametrizacao,
            ...registroVacinacao,
            ...relatorioConsolidadoAplicacao,
            ...relatorioDeAplicacao,
            ...requisicao,
            ...salaVacinacao,
        ]
    }
]